import { render } from "./MaintenanceView.vue?vue&type=template&id=78fa7400"
const script = {}

import exportComponent from "/Users/damon/workspace/authweb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__